import React from "react";

const ViewPayment = ({ to, translationMap }) => {
  return (
    <div className="content_box2">
          <h6>
              {translationMap?.want_to_view_previous_payment}
          </h6>
          <div className="btn_box">
              <a href={`/portalservices/eservices${to}`} className="blue_btn_link">
                  {translationMap?.payment_history}
              </a>
          </div>
      </div>);

};

export default ViewPayment;